import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import MapelBabService from '../../services/mapelBabServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('mapelbab/list', async ({ jenjangID, mapelID, page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await MapelBabService.getList(jenjangID, mapelID, page, perPage, sort, orderBy, search);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('mapelbab/create', async ({ jenjangID, mapelID, data }, thunkAPI) => {
  try {
    const response = await MapelBabService.create(jenjangID, mapelID, data);

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('mapelbab/read', async ({ jenjangID, mapelID, id }, thunkAPI) => {
  try {
    const response = await MapelBabService.read(jenjangID, mapelID, id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('mapelbab/update', async ({ jenjangID, mapelID, data }, thunkAPI) => {
  try {
    const response = await MapelBabService.update(jenjangID, mapelID, data.id, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('mapelbab/delete', async ({ jenjangID, mapelID, id }, thunkAPI) => {
  try {
    const response = await MapelBabService.del(jenjangID, mapelID, id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('mapelbab/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await MapelBabService.changeStatus(data.jenjangID, data.mapelID, data.id, data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [] };

const mapelSlice = createSlice({
  name: 'mapelbab',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = mapelSlice;
export default reducer;
